import React from 'react'
import useTranslation from '../shared/TranslationProvider'
import useShortCourses from './ShortCourseProvider'
import { cn } from '../../lib/utils'
import Card from './Cards'
import { useIsMobile } from '../../hooks/useMediaQuery'

const SubNav = () => {
  const { currentCourse, activeSubNav, setActiveSubNav } = useShortCourses()
  const slug = currentCourse.slug
  const { t } = useTranslation(`${slug}.overview`)
  const isMobile = useIsMobile()

  const subNavItems = t('subnav')
  return (
    <>
      <div
        className={cn(
          'mx-4 p-2 md:mx-10 md:mt-12 md:border-b md:border-[#e5e5e5] md:p-0',
          isMobile ? 'overflow-x-auto' : 'sm:static sm:overflow-auto',
        )}
      >
        <div
          className={cn(
            'mt-6 flex gap-6 md:gap-12',
            isMobile ? 'min-w-max flex-nowrap px-4' : 'flex-wrap',
          )}
        >
          {subNavItems.map((item, idx) => {
            const title = item.title
            const itemSlug = item.slug
            return (
              <SubNavButton
                key={`${itemSlug}-${idx}`}
                onClick={() => setActiveSubNav(itemSlug)}
                active={itemSlug === activeSubNav}
              >
                {title}
              </SubNavButton>
            )
          })}
        </div>
      </div>
      <Card />
    </>
  )
}

export default SubNav

const SubNavButton = ({ active, children, ...props }) => {
  return (
    <button
      {...props}
      className="flex min-w-[5rem] flex-col items-center whitespace-nowrap"
    >
      <div
        className={cn(
          'my-2 text-center text-sm text-black md:text-xl',
          active && 'font-bold',
        )}
      >
        {children}
      </div>
      <div
        className={cn(active ? 'h-1 w-full rounded-t-sm bg-primary' : 'h-1')}
      ></div>
    </button>
  )
}
